import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TrackJS } from "trackjs";
import { computed, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";

import API from "@/api/index";

import AuthLayout from "@/layouts/AuthLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import ls from "@/services/local-storage";
import { useAuthStore } from "@/stores/auth.store";
import { useUsersStore } from "@/stores/users.store";

import { useStoreManager } from "@/composables/store-manager";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const usersStore = useUsersStore();
const authStore = useAuthStore();

const route = useRoute();
const router = useRouter();

const { populateOrganizationData, populateGeneralData } = useStoreManager();

const isAuthPage = computed<boolean>(() => {
  return route.name === "authStart" || route.name === "authEnd";
});
const validateAPIToken = async (): Promise<boolean> => {
  try {
    await API.product.getAll();
    return true;
  } catch (error: any) {
    return error.response.status !== 401;
  }
};
const handleValidToken = async () => {
  await populateOrganizationData();
  populateGeneralData();
  const currentUser = usersStore.currentUser;
  if (currentUser) {
    TrackJS.configure({
      userId: String(currentUser.id)
    });
    TrackJS.addMetadata("logged-in-via", "browser");
  }
};
const handleInvalidToken = async () => {
  ls.clearToken();
  authStore.clearLoggedIn();
  await router.push({ name: "login" });
};
// Another tab changed who is logged in: reload so this tab shows that
// account's pages and permissions instead of the old user's.
const stopWatchingToken = ls.onTokenChange(() => window.location.reload());
onUnmounted(stopWatchingToken);

onMounted(async () => {
  if (router.currentRoute && !isAuthPage.value && ls.isTokenSet()) {
    authStore.setLoggedIn();

    const isValid = await validateAPIToken();
    isValid ? await handleValidToken() : await handleInvalidToken();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta.layout === 'auth' ? AuthLayout : MainLayout)))
}
}

})